// Backport from AngularJS (webroot/_ui/desktop/common/js/angular/controllers/cartPageController.js)
import logger from '../utils/rbata.logger';
import urlService from '../services/rbata.urlService';
import cartTracking from '../tracking/rbata.tracking.cart';
import consumerEvents from '../tracking/rbata.consumer-events';
import spinner from '../utils/rbata.spinner';

const selectQuantity = {
    $body:               undefined,
    init() {
        this.$body               = $('body');
        this.bindEvents();
    },

    updateQuantityRequest(entryNumber, newQuantity) {
        return $.ajax({
            url:         `${urlService.getBaseUrl()}cart/updateCartItem`,
            method:      'POST',
            dataType:    'json',
            contentType: 'application/json',
            data:        JSON.stringify({
                entryNumber: entryNumber,
                amount:      newQuantity
            })
        });
    },

    updateQuantity(entryNumber, oldQuantity, newQuantity, cartAction) {
        spinner.visibility(true);
        this.updateQuantityRequest(entryNumber, newQuantity)
            .done((response) => {
                $(`.js-cart__item-error-${entryNumber}`).empty();
                if (response.success === true) {
                    if (response.trackingProductData) {
                        cartTracking.trackCartAction(cartAction, response.trackingProductData, oldQuantity, newQuantity);
                        consumerEvents.trackUpdateCartEvent(response.trackingProductData, oldQuantity, newQuantity);
                    }
                    setTimeout(() => {
                        window.location.reload();
                    }, 250);
                } else {
                    $(`.js-cart__item-error-${entryNumber}`).html(response.message)
                    spinner.visibility(false);
                    if (response.outOfStockEntries.length) {
                        // if there are outOfStockEntries in the response, success is false but product amount is changed
                        setTimeout(() => {
                            window.location.reload();
                        }, 1000);
                    }
                }
            })
            .fail((jqXHR) => {
                logger.error(`${jqXHR.status} error in selectQuantity.updateQuantity`);
                window.location.reload();
            });
    },

    changeAmount(cartAction, evt) {
        const dataset = evt.currentTarget.dataset;
        selectQuantity.updateQuantity(
                dataset.entryNumber,
                dataset.oldQuantity,
                dataset.newQuantity,
                cartAction
        );
    },

    bindEvents() {
        this.$body.on('click', '.js-cart__dec', selectQuantity.changeAmount.bind(this, 'removeFromCart'));
        this.$body.on('click', '.js-cart__inc', selectQuantity.changeAmount.bind(this, 'addToCart'));
    }
};

$(() => {
    if ($('#cart-page').length) {
        selectQuantity.init();
    }
});

export default selectQuantity;